<div class="modal-content">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" (click)="modalAddress.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane contact-tab-0 tab-content-child fade show active" id="v-pills-user" role="tabpanel"
                 aria-labelledby="v-pills-user-tab">
                <div class="profile-mail">
                    <div class="d-flex">
                        <img class="img-fluid m-r-20 rounded-circle update_img_0" src="assets/img/backlog/address.png" alt="">
                        <input class="updateimg" type="file">
                        <div class="flex-grow-1 mt-0">
                            <h3><span class="first_name_0">Dirección</span>
                            </h3>
                            <p class="email_add_0">{{title}}</p>
                        </div>
                    </div>

                    <div class="email-general">
                        <h6 class="mb-3"></h6>
                        <ul class="list-unstyled">
                            <li class="d-flex justify-content-between">
                                <span>País</span>
                                <span class="font-primary first_name_0">{{address.country_description}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Ciudad</span>
                                <span class="font-primary city_0">{{address.city_description}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Código postal</span>
                                <span class="font-primary">{{address.postal_code}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Colonia/Localidad</span>
                                <span class="font-primary personality_0">{{address.locality}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Calle</span>
                                <span class="font-primary mobile_num_0">{{address.street}}</span>
                            </li>
                            <li class="d-flex justify-content-between" *ngIf="address.number_int">
                                <span>Número interior</span>
                                <span class="font-primary email_add_0">{{address.number_int}}</span>
                            </li>
                            <li class="d-flex justify-content-between">
                                <span>Número exterior</span>
                                <span class="font-primary url_add_0">{{address.number_ext}}</span>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
